<template>
    <LayoutDashboard title="Categorias">
            <v-card outlined>
                <v-card-title>
                    <v-btn color="primary" @click="cadastrarGrupoFinanceiro" outlined v-if="$helper.verificaPermissao('cadastrar-categoria-financeiro')">Cadastrar</v-btn>
                    <v-spacer></v-spacer>
                    <v-text-field outlined dense v-model="search" append-icon="search" label="Pesquisar" single-line hide-details>
                    </v-text-field>
                </v-card-title>
                <v-card-text>
                    <v-data-table :headers="headers" :items="getGruposFinanceiro" :search="search" dense>
                        <template v-slot:item.action="{ item }">
                            <v-btn color="primary" outlined small @click="visualizarGrupoFinanceiro(item)" v-if="$helper.verificaPermissao('visualizar-categoria-financeiro')">Visualizar</v-btn>
                        </template>
                    </v-data-table>
                </v-card-text>
            </v-card>
            <ModalCadastro />
    </LayoutDashboard>
</template>

<script>
    import ModalCadastro from "@/pages/financeiro/grupo/ModalCadastro"
    import { mapGetters, mapActions } from "vuex"

    export default {
        components: {
            ModalCadastro
        },
        data() {
            return {
                search: '',
                headers: [
                    { text: '#', value: 'id', sortable: false },
                    { text: 'Nome', align: 'left', sortable: false, value: 'nome'},
                    { text: 'Ações', value: 'action', sortable: false }
                ],
                funcionarios: [],
            }
        },
        computed: {
            ...mapGetters([
                'getGruposFinanceiro',
                'getModalCadastroGrupoFinanceiro'
            ])
        },
        methods: {
            ...mapActions([
                'listarGrupoFinanceiro',
                'visualizarGrupoFinanceiro',
                'cadastrarGrupoFinanceiro',
                'listarPermissao'
            ])
        },
        created() {
            this.listarGrupoFinanceiro()
            this.listarPermissao()
        }
    }
</script>